module.exports = __webpack_public_path__ + "images/87dd11dd2de2553da7b27fa7a0e4a848-illu_panelPlacement.svg";